import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/pages"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function RegisterEntry (){
  const {user} = useUser()
  let view = contentLayout[modules.RegisterEntry]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.RegisterEntry.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.RegisterEntry}></Index>
 )
}

export default RegisterEntry